import script from "./GaleriaFotosGrid.vue?vue&type=script&setup=true&lang=js"
export * from "./GaleriaFotosGrid.vue?vue&type=script&setup=true&lang=js"

import "./GaleriaFotosGrid.vue?vue&type=style&index=0&id=470fee07&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-470fee07"]])

export default __exports__